import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import CONSTANTS from '../../_constants/constants';
import { environment } from '../../../environments/environment';
import { DefaultParams } from '../../_shared/interfaces/defaultParams';

import { UtilService } from '../../_shared/services/util.service';

import { WhatToBring } from './what-to-bring.model';

interface ExtendedDefaultParams extends DefaultParams {
  by_name?: any;
}

@Injectable({
  providedIn: 'root',
})
export class WhatToBringService {
  constructor(private http: HttpClient, private utilService: UtilService) {}

  private apiUrl = environment.apiEndpoint + 'what_to_bring';

  getFilterCriteria() {
    let defaultParams: ExtendedDefaultParams = {
      page: 1,
      sortDir: 'asc',
      sortedBy: 'name',
    };

    return defaultParams;
  }

  getWhatToBrings(params = null): Observable<any> {
    if (!params) {
      params = this.getFilterCriteria();
    }

    let queryParams = new HttpParams({ fromObject: params });

    return this.http.get(this.apiUrl, { params: queryParams }).pipe(
      map((resp) => {
        if (resp['data']) {
          return {
            data: resp['data'],
            meta: this.utilService.getItemsMetaData(resp, this.getFilterCriteria()),
          };
        } else {
          return resp;
        }
      })
    );
  }

  getWhatToBring(id: string, params = null): Observable<WhatToBring> {
    let queryParams = new HttpParams({ fromObject: params });

    return this.http.get<WhatToBring>(`${this.apiUrl}/${id}`, {
      params: queryParams,
    });
  }

  // Save / Update
  saveWhatToBring(
    whatToBringId: string,
    whatToBring: WhatToBring,
    lang = ''
  ): Observable<WhatToBring> {
    const body = {
      what_to_bring: whatToBring,
      lang: lang || CONSTANTS.DEFAULT_CONTENT_LANGUAGE,
    };

    if (!whatToBringId) {
      return this.http.post<WhatToBring>(`${this.apiUrl}`, body);
    } else {
      return this.http.put<WhatToBring>(`${this.apiUrl}/${whatToBringId}`, body);
    }
  }
}
